<script>
const enums = {
  ProductType: {
    ElectronBook: 1,
    SoundBook: 2,
    Periodical: 3,
    Subjournal: 31,
  },
};
export default {
  enums
};
</script>



// WEBPACK FOOTER //
// src/common/GlobalVariable.vue